import React, { useCallback, useRef } from "react";
import styled from "styled-components";
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import { BackBarButtonMini } from "../../common/backBarButton";
import { MoviesSlider } from "./categoryList";
import smoothScroll from "../../../utils/animateScroll";
import {
  PROFILE_COLORS,
  PROFILE_FONT_SIZES,
  PROFILE_SPACING,
  PROFILE_RADIUS,
  FONT_FAMILY,
} from "../styles/profileStyles";
import { useInputMode } from "../../../utils/hooks/useInputMode";

// ============================================================================
// STYLED COMPONENTS
// ============================================================================

var ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: table;
  font-family: ${FONT_FAMILY};
`;

var ContentInner = styled.div`
  display: table-cell;
  vertical-align: top;
  padding: ${PROFILE_SPACING.lg} ${PROFILE_SPACING.xxl};
  padding-bottom: 0;
`;

var ScrollContainer = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
`;

var HeaderRow = styled.div`
  display: table;
  width: 100%;
  margin-bottom: ${PROFILE_SPACING.lg};
`;

var HeaderCell = styled.div`
  display: table-cell;
  vertical-align: middle;
`;

var PageTitle = styled.h4`
  color: ${PROFILE_COLORS.text};
  font-size: ${PROFILE_FONT_SIZES.title};
  font-weight: 700;
  margin: 0;
  margin-right: ${PROFILE_SPACING.md};
  display: inline-block;
`;

var ContentContainer = styled.div`
padding-bottom: 5rem;
`;

var EmptyState = styled.div`
  background: ${PROFILE_COLORS.cardBg};
  color: ${PROFILE_COLORS.text};
  padding: ${PROFILE_SPACING.lg};
  border-radius: ${PROFILE_RADIUS.lg};
  font-size: ${PROFILE_FONT_SIZES.body};
`;

// ============================================================================
// MAIN COMPONENT
// ============================================================================

var GridContent = function (props) {
  const { data, slug, title } = props;
  var { ref, focusKey } = useFocusable();
  var innerRef = useRef(null);
  var { isMouseFocus } = useInputMode();

  var onRowFocus = useCallback(
    function (focusProps) {
      if (isMouseFocus) return;
      var y = focusProps.y;
      var height = focusProps.height;
      var targetScroll = y > height - 200 ? y - 200 : 0;
      smoothScroll(ref, targetScroll, 500);
    },
    [ref, isMouseFocus]
  );

  return (
    <ContentWrapper>
      <ContentInner>
        <FocusContext.Provider value={focusKey}>
          <ScrollContainer ref={ref}>
            <div>
              <HeaderRow>
                <HeaderCell>
                  <BackBarButtonMini />
                  <PageTitle>{title}</PageTitle>
                </HeaderCell>
              </HeaderRow>

              <ContentContainer ref={innerRef}>
                {data && data.length > 0 ? (
                  <MoviesSlider
                    movies={data}
                    onFocus={onRowFocus}
                    slug={slug}
                    isWatchHistory={props.isWatchHistory || title === "تاریخچه تماشا"}
                  />
                ) : (
                  <EmptyState>
                    <p>محتوایی یافت نشد</p>
                  </EmptyState>
                )}
              </ContentContainer>
            </div>
          </ScrollContainer>
        </FocusContext.Provider>
      </ContentInner>
    </ContentWrapper>
  );
};

export default GridContent;
